import request from 'superagent';
// import * as APIFactory from '../factories/api';

const ENDPOINT = process.env.REACT_APP_API_URL;
const API_KEY = process.env.REACT_APP_API_KEY;

/**
 * Get a team's current roster
 * @param {*} teamId ID of team to fetch
 */
export async function getTeamRoster(teamId, matchId, teamNumber) {
  var queryUri = null;
  if (matchId) {
    queryUri = encodeURI(`${ENDPOINT}/teams/rosterForMatch/${matchId}/${teamNumber}`)
  } else {
    queryUri = encodeURI(`${ENDPOINT}/teams/${teamId}/roster`)
  }
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body;
  } catch (error) {
    console.log(error)
    return [];
  }
}

/**
 * Get full list of leagues that are published to OE.
 */
export async function getLeagues() {
  const queryUri = encodeURI(`${ENDPOINT}/leagues/getLeagues`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Get full list of leagues that are published to OE.
 */
export async function getLeagueRegions() {
  const queryUri = encodeURI(`${ENDPOINT}/leagues/getLeagueRegions`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Get a list of the tournaments with the most recent games.
 */
export async function getLatestTournaments() {
  const queryUri = encodeURI(`${ENDPOINT}/tournaments/latest`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Get the most recent tournament for each league.
 */
export async function getLatestTournamentsByLeague() {
  const queryUri = encodeURI(`${ENDPOINT}/tournaments/latestByLeague`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Get full list of tournaments for each league.
 */
export async function getTournamentsByLeague() {
  const queryUri = encodeURI(`${ENDPOINT}/tournaments/byLeague`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Query tournament metadata for a given tournament ID.
 * @param {*} tournamentId, ID of tournament
 */
export async function getTournamentMetadata(tournamentId) {
  const queryUri = encodeURI(`${ENDPOINT}/tournaments/`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY)
      .query({ tournamentId: tournamentId });
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Query the current stats definitions.
 */
export async function getStatsDefinitions() {
  const queryUri = encodeURI(`${ENDPOINT}/definitions`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Query a set of player stats for a given tournament ID.
 * @param {*} tournamentId, ID of tournament
 * @param {*} columnSet, optional, 'china' for limited columns from lol.QQ.com data
 * @param {*} format, optional, 'json' to get JSON-formatted results
 */
export async function getPlayerStatsForTournament(tournamentId, columnSet = null, format = null, filters = {}) {
  const queryUri = encodeURI(`${ENDPOINT}/stats/players/byTournament?${Object.keys(filters).map(filter => `${filter}=${filters[filter]}`).join('&')}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY)
      .query({ tournament: tournamentId, columnSet: columnSet });
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Query a set of team stats for a given tournament ID.
 * @param {*} tournamentId, ID of tournament
 * @param {*} columnSet, optional, 'qq' for limited columns from lol.QQ.com data
 * @param {*} format, optional, 'json' to get JSON-formatted results
 */
export async function getTeamStatsForTournament(tournamentId, columnSet = null, format = null, filters = {}) {
  const queryUri = encodeURI(`${ENDPOINT}/stats/teams/byTournament?${Object.keys(filters).map(filter => `${filter}=${filters[filter]}`).join('&')}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY)
      .query({ tournament: tournamentId, columnSet: columnSet });
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Query a set of player stats for a given tournament ID.
 * @param {*} tournamentId, ID of tournament
 * @param {*} columnSet, optional, 'china' for limited columns from lol.QQ.com data
 */
export async function getChampionStatsForTournament(columnSet = null, filters = {}) {
  const queryUri = encodeURI(`${ENDPOINT}/stats/champions?${Object.keys(filters).map(filter => `${filter}=${filters[filter]}`).join('&')}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY)
      .query({ columnSet: columnSet });
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Query a set of player stats for a given tournament ID.
 * @param {*} filters, optional, set of filters
 */
export async function getChampionStatsForExplorer(filters = {}) {
  const queryUri = encodeURI(`${ENDPOINT}/stats/champions?${Object.keys(filters).map(filter => `${filter}=${filters[filter]}`).join('&')}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Query a set of player stats for a given tournament ID.
 * @param {*} filters, optional, set of filters
 */
export async function getSoloQueueChampionsForPatch(patch) {
  const queryUri = encodeURI(`${ENDPOINT}/soloQueue/champions?patch=${patch}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Query a set of player stats for a given tournament ID.
 * @param {*} filters, optional, set of filters
 */
export async function getSoloQueueMatchupStats(filters = {}) {
  const queryUri = encodeURI(`${ENDPOINT}/soloQueue/matchups?${Object.keys(filters).map(filter => `${filter}=${filters[filter]}`).join('&')}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Query the patch range for a given tournament, or all games.
 */
export async function getPatchRange({ tournament = null, player = null }) {
  var queryUri = null;
  if (tournament !== null) {
    queryUri = encodeURI(`${ENDPOINT}/patches/tournament/${encodeURIComponent(tournament)}`)
  } else if (player !== null) {
    queryUri = encodeURI(`${ENDPOINT}/patches/player/${encodeURIComponent(player)}`)
  } else {
    queryUri = encodeURI(`${ENDPOINT}/patches`)
  }
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Query the patch range for a given tournament, or all games.
 */
export async function getSoloQueuePatchRange() {
  const queryUri = encodeURI(`${ENDPOINT}/patches/soloQueue`);
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Get list of downloadable match data files
 */
export async function getMatchDataDownloadList() {
  const queryUri = encodeURI(`${ENDPOINT}/matchData`);
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Query current EGR coefficients.
 */
export async function getEgrCoefficients() {
  const queryUri = encodeURI(`${ENDPOINT}/egr`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch a list of players.
 */
export async function searchPlayers(searchTerm) {
  const searchTermEncoded = encodeURIComponent(searchTerm);
  const queryUri = encodeURI(`${ENDPOINT}/players/search?search=${searchTermEncoded}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch a player's basic profile info.
 */
export async function getPlayerProfile(playerId) {
  const queryUri = encodeURI(`${ENDPOINT}/players/${playerId}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch details from a player's recent games.
 */
export async function getPlayerGameDetails(playerId, filters = {}) {
  const queryUri = encodeURI(`${ENDPOINT}/players/gameDetails/${playerId}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch a player's career stats by year.
 */
export async function getPlayerCareerStatsByYear(playerId, filters = {}) {
  const queryUri = encodeURI(`${ENDPOINT}/players/careerStatsByYear/${playerId}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch a player's career stats by split.
 */
export async function getPlayerCareerStatsBySplit(playerId, filters = {}) {
  const queryUri = encodeURI(`${ENDPOINT}/players/careerStatsBySplit/${playerId}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch a player's career champion pool.
 */
export async function getPlayerCareerChampionPool(playerId, filters = {}) {
  const queryUri = encodeURI(`${ENDPOINT}/players/championPool/${playerId}?${Object.keys(filters).map(filter => `${filter}=${filters[filter]}`).join('&')}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch a list of teams.
 */
export async function searchTeams(searchTerm) {
  const searchTermEncoded = encodeURIComponent(searchTerm);
  const queryUri = encodeURI(`${ENDPOINT}/teams/search?search=${searchTermEncoded}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch a team's basic profile info.
 */
export async function getTeamProfile(teamId) {
  const queryUri = encodeURI(`${ENDPOINT}/teams/${teamId}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch a team's stats by year.
 */
export async function getTeamStatsByYear(teamId, filters = {}) {
  const queryUri = encodeURI(`${ENDPOINT}/teams/statsByYear/${teamId}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch a team's stats by split.
 */
export async function getTeamStatsBySplit(teamId, filters = {}) {
  const queryUri = encodeURI(`${ENDPOINT}/teams/statsBySplit/${teamId}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch list of team's drafts.
 */
export async function getTeamDrafts(teamId, filters) {
  const queryUri = encodeURI(`${ENDPOINT}/teams/${teamId}/drafts?${Object.keys(filters).map(filter => `${filter}=${filters[filter]}`).join('&')}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch details from a team's recent games.
 */
export async function getTeamGameDetails(teamId, filters = {}) {
  const queryUri = encodeURI(`${ENDPOINT}/teams/gameDetails/${teamId}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY)
      .query({ beforeTime: filters.beforeTime });
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch details for a single game.
 */
 export async function getSingleGame(gameId) {
  const queryUri = encodeURI(`${ENDPOINT}/games/singleGame/${gameId}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body[0];
  } catch (error) {
    return error;
  }
}

/**
 * Fetch a single game's draft.
 */
 export async function getSingleGameDraft(gameId) {
  const queryUri = encodeURI(`${ENDPOINT}/drafts/${gameId}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch details for a single match.
 */
export async function getSingleMatch(matchId) {
  const queryUri = encodeURI(`${ENDPOINT}/matches/singleMatch/${matchId}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body[0];
  } catch (error) {
    return error;
  }
}

/**
 * Query matches in next 24 hours.
 */
export async function getUpcomingMatches() {
  const queryUri = encodeURI(`${ENDPOINT}/matches/upcoming/`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body;
  } catch (error) {
    return error;
  }
}

/**
 * Query upcoming matches for a team.
 */
export async function getUpcomingMatchesForTeam(teamId) {
  const queryUri = encodeURI(`${ENDPOINT}/teams/${teamId}/upcoming`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body;
  } catch (error) {
    return error;
  }
}

/**
 * Query live matches.
 */
export async function getLiveMatches() {
  const testMode = false;
  const queryUri = encodeURI(`${ENDPOINT}/matches/live/`)
  if (testMode) {
    return [
      {
        "state": "completed",
        "matchId": "106926282334990205",
        "seriesType": "bestOf5",
        "league": "WLDs",
        "tournamentId": "2021 Season World Championship",
        "tournamentName": "Worlds 2021",
        "liveStreams": "[{\"parameter\": \"summonersinnlive\", \"locale\": \"de-DE\", \"provider\": \"twitch\", \"countries\": [\"DE\"], \"offset\": -100000}, {\"parameter\": \"n7yiF8C7F-Q\", \"locale\": \"de-DE\", \"provider\": \"youtube\", \"countries\": [\"DE\"], \"offset\": -50000}, {\"parameter\": \"esport2tv\", \"locale\": \"hu-HU\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -100000}, {\"parameter\": \"7daiALgbBCo\", \"locale\": \"hu-HU\", \"provider\": \"youtube\", \"countries\": [], \"offset\": -50000}, {\"parameter\": \"riotgames\", \"locale\": \"en-US\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -80000}, {\"parameter\": \"riotgames\", \"locale\": \"en-US\", \"provider\": \"trovo\", \"countries\": [], \"offset\": 0}, {\"parameter\": \"Lnbfo5sV_nI\", \"locale\": \"en-US\", \"provider\": \"youtube\", \"countries\": [], \"offset\": -50000}, {\"parameter\": \"cblol\", \"locale\": \"pt-BR\", \"provider\": \"twitch\", \"countries\": [\"BR\"], \"offset\": -50000}, {\"parameter\": \"vJ0aBnndAsE\", \"locale\": \"pt-BR\", \"provider\": \"youtube\", \"countries\": [], \"offset\": -50000}, {\"parameter\": \"lck_korea\", \"locale\": \"ko-KR\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -100000}, {\"parameter\": \"aflol\", \"locale\": \"ko-KR\", \"provider\": \"afreecatv\", \"countries\": [], \"offset\": 0}, {\"parameter\": \"lvpes\", \"locale\": \"es-ES\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -80000}, {\"parameter\": \"lla\", \"locale\": \"es-MX\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -90000}, {\"parameter\": \"eklc5m0xDzU\", \"locale\": \"es-MX\", \"provider\": \"youtube\", \"countries\": [], \"offset\": -50000}, {\"parameter\": \"LLA\", \"locale\": \"es-MX\", \"provider\": \"trovo\", \"countries\": [], \"offset\": 0}, {\"parameter\": \"pg_esports_lol\", \"locale\": \"it-IT\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -85000}, {\"parameter\": \"riotgamesru\", \"locale\": \"ru-RU\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -85000}, {\"parameter\": \"7aUE27oJLYI\", \"locale\": \"ru-RU\", \"provider\": \"youtube\", \"countries\": [], \"offset\": -50000}, {\"parameter\": \"8AcyUJ5WRKg\", \"locale\": \"pl-PL\", \"provider\": \"youtube\", \"countries\": [\"PL\"], \"offset\": 0}, {\"parameter\": \"VSg_YZ5HDuw\", \"locale\": \"tr-TR\", \"provider\": \"youtube\", \"countries\": [], \"offset\": -50000}, {\"parameter\": \"riotgamesturkish\", \"locale\": \"tr-TR\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -90000}, {\"parameter\": \"hitpointcz\", \"locale\": \"cs-CZ\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -60000}, {\"parameter\": \"otplol_\", \"locale\": \"fr-FR\", \"provider\": \"twitch\", \"countries\": [\"FR\", \"CA\"], \"offset\": -100000}, {\"parameter\": \"riotgamesjp\", \"locale\": \"ja-JP\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -85000}]",
        "leagueName": "World Championship",
        "team1Id": "Beyond Gaming",
        "team1Name": "Beyond Gaming",
        "team1Code": "BYG",
        "team1Logo": "106269804045322803.png",
        "team1Score": "0",
        "blueTopChampion": "Tryndamere",
        "blueTopSummoner": "BYG Liang",
        "blueJungleChampion": "LeeSin",
        "blueJungleSummoner": "BYG Husha",
        "blueMidChampion": "Gwen",
        "blueMidSummoner": "BYG PK",
        "blueBotChampion": "Aphelios",
        "blueBotSummoner": "BYG Doggo",
        "blueSupportChampion": "Thresh",
        "blueSupportSummoner": "BYG Kino",
        "redTopChampion": "Irelia",
        "redTopSummoner": "HLE Morgan",
        "redJungleChampion": "Nidalee",
        "redJungleSummoner": "HLE Willer",
        "redMidChampion": "Fiora",
        "redMidSummoner": "HLE Chovy",
        "redBotChampion": "MissFortune",
        "redBotSummoner": "HLE Deft",
        "redSupportChampion": "Leona",
        "team2Id": "Hanwha Life Esports",
        "redSupportSummoner": "HLE Vsta",
        "team2Name": "Hanwha Life Esports",
        "team2Code": "HLE",
        "team2Logo": "100205573496804586Alternative.png",
        "team2Score": "3",
        "startTime": "2021-10-09 11:00:00",
        "blockName": "Play In Knockouts, Day 2",
        "liveGameNumber": "1",
        "liveGameState": "finished",
        "blueTeamCode": "BYG",
        "redTeamCode": "HLE",
        "liveStats": "{\"rfc460Timestamp\": \"2021-10-09T11:42:13.258Z\", \"gameState\": \"finished\", \"blueTeam\": {\"totalGold\": 46730, \"inhibitors\": 0, \"towers\": 3, \"barons\": 0, \"totalKills\": 6, \"dragons\": [], \"participants\": [{\"participantId\": 1, \"totalGold\": 9719, \"level\": 14, \"kills\": 2, \"deaths\": 1, \"assists\": 2, \"creepScore\": 188, \"currentHealth\": 1125, \"maxHealth\": 2473}, {\"participantId\": 2, \"totalGold\": 7996, \"level\": 13, \"kills\": 0, \"deaths\": 5, \"assists\": 3, \"creepScore\": 150, \"currentHealth\": 12, \"maxHealth\": 2255}, {\"participantId\": 3, \"totalGold\": 9513, \"level\": 15, \"kills\": 0, \"deaths\": 4, \"assists\": 4, \"creepScore\": 224, \"currentHealth\": 148, \"maxHealth\": 2113}, {\"participantId\": 4, \"totalGold\": 13023, \"level\": 13, \"kills\": 3, \"deaths\": 4, \"assists\": 0, \"creepScore\": 322, \"currentHealth\": 106, \"maxHealth\": 1593}, {\"participantId\": 5, \"totalGold\": 6479, \"level\": 11, \"kills\": 1, \"deaths\": 4, \"assists\": 3, \"creepScore\": 31, \"currentHealth\": 0, \"maxHealth\": 1813}], \"activeBaron\": 0, \"activeElder\": 0, \"killedInhibs\": 1}, \"redTeam\": {\"totalGold\": 57531, \"inhibitors\": 1, \"towers\": 8, \"barons\": 0, \"totalKills\": 18, \"dragons\": [\"ocean\", \"infernal\", \"cloud\"], \"participants\": [{\"participantId\": 6, \"totalGold\": 11581, \"level\": 15, \"kills\": 2, \"deaths\": 2, \"assists\": 5, \"creepScore\": 253, \"currentHealth\": 0, \"maxHealth\": 2779}, {\"participantId\": 7, \"totalGold\": 11323, \"level\": 15, \"kills\": 5, \"deaths\": 1, \"assists\": 12, \"creepScore\": 180, \"currentHealth\": 1726, \"maxHealth\": 2120}, {\"participantId\": 8, \"totalGold\": 13616, \"level\": 17, \"kills\": 5, \"deaths\": 1, \"assists\": 5, \"creepScore\": 291, \"currentHealth\": 903, \"maxHealth\": 2766}, {\"participantId\": 9, \"totalGold\": 13717, \"level\": 15, \"kills\": 5, \"deaths\": 0, \"assists\": 9, \"creepScore\": 303, \"currentHealth\": 1795, \"maxHealth\": 1803}, {\"participantId\": 10, \"totalGold\": 7294, \"level\": 12, \"kills\": 1, \"deaths\": 2, \"assists\": 13, \"creepScore\": 38, \"currentHealth\": 977, \"maxHealth\": 1882}], \"activeBaron\": 0, \"activeElder\": 0, \"killedInhibs\": 2}}"
      }
      ,
      {
        "state": "inProgress",
        "matchId": "105913088925019701",
        "seriesType": "bestOf3",
        "league": "LCS.A",
        "liveStreams": "[{\"parameter\": \"summonersinnlive\", \"locale\": \"de-DE\", \"provider\": \"twitch\", \"countries\": [\"DE\"], \"offset\": -100000}, {\"parameter\": \"n7yiF8C7F-Q\", \"locale\": \"de-DE\", \"provider\": \"youtube\", \"countries\": [\"DE\"], \"offset\": -50000}, {\"parameter\": \"esport2tv\", \"locale\": \"hu-HU\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -100000}, {\"parameter\": \"7daiALgbBCo\", \"locale\": \"hu-HU\", \"provider\": \"youtube\", \"countries\": [], \"offset\": -50000}, {\"parameter\": \"riotgames\", \"locale\": \"en-US\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -80000}, {\"parameter\": \"riotgames\", \"locale\": \"en-US\", \"provider\": \"trovo\", \"countries\": [], \"offset\": 0}, {\"parameter\": \"Lnbfo5sV_nI\", \"locale\": \"en-US\", \"provider\": \"youtube\", \"countries\": [], \"offset\": -50000}, {\"parameter\": \"cblol\", \"locale\": \"pt-BR\", \"provider\": \"twitch\", \"countries\": [\"BR\"], \"offset\": -50000}, {\"parameter\": \"vJ0aBnndAsE\", \"locale\": \"pt-BR\", \"provider\": \"youtube\", \"countries\": [], \"offset\": -50000}, {\"parameter\": \"lck_korea\", \"locale\": \"ko-KR\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -100000}, {\"parameter\": \"aflol\", \"locale\": \"ko-KR\", \"provider\": \"afreecatv\", \"countries\": [], \"offset\": 0}, {\"parameter\": \"lvpes\", \"locale\": \"es-ES\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -80000}, {\"parameter\": \"lla\", \"locale\": \"es-MX\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -90000}, {\"parameter\": \"eklc5m0xDzU\", \"locale\": \"es-MX\", \"provider\": \"youtube\", \"countries\": [], \"offset\": -50000}, {\"parameter\": \"LLA\", \"locale\": \"es-MX\", \"provider\": \"trovo\", \"countries\": [], \"offset\": 0}, {\"parameter\": \"pg_esports_lol\", \"locale\": \"it-IT\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -85000}, {\"parameter\": \"riotgamesru\", \"locale\": \"ru-RU\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -85000}, {\"parameter\": \"7aUE27oJLYI\", \"locale\": \"ru-RU\", \"provider\": \"youtube\", \"countries\": [], \"offset\": -50000}, {\"parameter\": \"8AcyUJ5WRKg\", \"locale\": \"pl-PL\", \"provider\": \"youtube\", \"countries\": [\"PL\"], \"offset\": 0}, {\"parameter\": \"VSg_YZ5HDuw\", \"locale\": \"tr-TR\", \"provider\": \"youtube\", \"countries\": [], \"offset\": -50000}, {\"parameter\": \"riotgamesturkish\", \"locale\": \"tr-TR\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -90000}, {\"parameter\": \"hitpointcz\", \"locale\": \"cs-CZ\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -60000}, {\"parameter\": \"otplol_\", \"locale\": \"fr-FR\", \"provider\": \"twitch\", \"countries\": [\"FR\", \"CA\"], \"offset\": -100000}, {\"parameter\": \"riotgamesjp\", \"locale\": \"ja-JP\", \"provider\": \"twitch\", \"countries\": [], \"offset\": -85000}]",
        "team1Id": "TSM Academy",
        "team1Name": "TSM Academy",
        "team1Code": "TSM",
        "team1Logo": "99566405127798575Alternative.png",
        "team1Score": "1",
        "team2Id": "Dignitas Mirage",
        "team2Name": "Dignitas Mirage",
        "team2Code": "DIGM",
        "team2Logo": "105957603362200620Alternative.png",
        "team2Score": "0",
        "startTime": "2021-04-09T00:00:00.000Z",
        "blockName": "Week 2",
        "liveGameNumber": "2",
        "liveGameState": "in_game",
        "blueTeamCode": "DIGM",
        "redTeamCode": "TSM"
      }
    ]
  }
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body;
  } catch (error) {
    return error;
  }
}

/**
 * Query recent match results.
 */
export async function getRecentResults() {
  const queryUri = encodeURI(`${ENDPOINT}/matches/recentResults/`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body;
  } catch (error) {
    return error;
  }
}

/**
 * Query recent VODs.
 */
export async function getRecentVods() {
  const queryUri = encodeURI(`${ENDPOINT}/matches/recentVods/`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body;
  } catch (error) {
    return error;
  }
}

/**
 * Query CQ Leaderboard.
 */
 export async function fetchCQLeaderboard(split) {
  const queryUri = encodeURI(`${ENDPOINT}/cq/leaderboard?split=${encodeURIComponent(split)}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body;
  } catch (error) {
    return error;
  }
}

/**
 * Query CQ Splits.
 */
 export async function fetchCQSplits() {
  const queryUri = encodeURI(`${ENDPOINT}/cq/splits`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.body;
  } catch (error) {
    return error;
  }
}

/**
 * Check whether a player is part of Champions Queue.
 */
 export async function checkIfPlayerIsInCq(playerId) {
  const queryUri = encodeURI(`${ENDPOINT}/cq/isPlayerInCq/${playerId}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res.text;
  } catch (error) {
    return error;
  }
}

/**
 * Fetch details from a player's recent Champions Queue games.
 */
 export async function getPlayerCqGameDetails(playerId, filters = {}) {
  const queryUri = encodeURI(`${ENDPOINT}/players/cqGameDetails/${playerId}`)
  try {
    const res = await request
      .get(queryUri)
      .set('X-Api-Key', API_KEY);
    return res;
  } catch (error) {
    return error;
  }
}
